module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAMAAAC7faEHAAAAUVBMVEUAAAAWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsToWsTruOliHAAAAGnRSTlMAcGBQIPnSgATFmZJrDunZrIuEZLx3ylhBOuVQkXEAAAC9SURBVDjL7dS5DsMgEEXRMQQwxvuS5f3/h8amIFOMwV0UKVdyYekwBdJALHU3EDJeE6/BaRNjCzKxiQNgJiUUDOAT6wA4EguAST+3OF2sAvBFt1iD/lV0I47GkmsRcyVnj+utdF1y+zfT3gVX/d3vusweNYCJLu1lqIR2Bv9xCpl0dMV3Yybm6OHld2jVlFy+vAt2ueKegOkuOA3gxt0ssrixaV7cS6eEth7o+alMjlL1eM7WmhhsrayGjbE3Ceoyyd7//FsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/download-coin-copy.png
// module id = 861
// module chunks = 12